import http from '../../http'
export default {
  number:(params)=> {
    return http.post('opservice/marketingCampaign/push/number',params)
  },
  list: (id, params) => {
    // 获取参会人列表
    // return http.post('activityservice/prticipantsearch/show/' + id, params)
    return http.post('activityservice/prticipantsearch/show/phone/' + id, params)
  },
  template: (params) => {
    return http.post('activityservice/prticipantsearch/download', params)
  },
  import: (params) => {
    return http.post('activityservice/prticipantsearch/import', params)
  },
  export: (params) => {
    return http.post('activityservice/prticipantExcl/export', params)
  },
  audit: (id, params) => {
    // 获取参会人列表
    return http.post('activityservice/contact/audit/' + id, params)
  },
  updateAll: (params) => {
    return http.post('activityservice/prticipant/batchupdate', params)
  },
  add: (params) => {
    return http.post('activityservice/prticipant/transfer', params)
  },
  del: (params) => {
    return http.post('activityservice/prticipant/delete', params)
  },
  delAll: (params) => {
    return http.post('activityservice/prticipant/batchdelete', params)
  },
  field: (params) => {
    return http.get('activityservice/prticipantsearch/field', params)
  },
  report: (params) => {
    return http.get('activityservice/contact/getinfo2/' + params)
  },
  // 获取导入日志
  getImportLog: (params) => {
    return http.post('activityservice/prticipantsearch/importLog', params)
  },
  // 获取导入日志详情
  getImportLogDetail: (params) => {
    return http.post('activityservice/prticipantsearch/importLog/detail', params)
  },
  // 获取导入日志Count
  getImportLogDetailCount: (params) => {
    return http.get('activityservice/prticipantsearch/importLog/detail/count', params)
  },
  uploadExcel: (data) => {
    return http.post('activityservice/prticipantExcl/put', data)
  },

  sendMessageUrl: (data) => {
    return http.post('activityservice/sms/send', data)
  }, //发送短信
  trunclue: (params) => {
    return http.post('activityservice/prticipant/toapplyformsubmit?id=' + params)
  },
  // 批量转线索
  clueBatch: (params) => {
    return http.post('activityservice/prticipant/toapplyformsubmit/batch', params)
  },
  // 发送邮件
  sendEmail:(id, params) => {
    return http.post('activityservice/prticipantsearch/sendmail/'+ id, params)
  }
}
